/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Search_PropertiesInputs */

const cs_filter_search_properties = /** @type {(inputs: Filter_Search_PropertiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat nemovitosti`)
};

const en_filter_search_properties = /** @type {(inputs: Filter_Search_PropertiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search properties`)
};

/**
* | output |
* | --- |
* | "Search properties" |
*
* @param {Filter_Search_PropertiesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const filter_search_properties = /** @type {((inputs?: Filter_Search_PropertiesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Search_PropertiesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filter_search_properties(inputs)
	return cs_filter_search_properties(inputs)
});